(function () {
    'use strict';

    angular.module('bizmetryApp').component('bizJsonPathSelector', {

        bindings: {
            attribute:   '<',
            jsonSample:  '<',
            mappingType: '@',
            currentPath: '<',
            onSave:      '&',
            onCancel:    '&'
        },

        templateUrl: '/common/components/biz-json-path-selector/json-path-selector.html',

        controller: ['$sce', '$timeout', function ($sce, $timeout) {
            var $ctrl = this;

            // ── State ─────────────────────────────────────────────────────
            $ctrl.selectedPath = null;
            $ctrl.pathPreview  = null;
            $ctrl.renderedTree = null;

            // Search state
            $ctrl.searchQuery  = '';
            $ctrl.matchCount   = 0;
            $ctrl.currentMatch = 0;

            var _parsedJson      = {};
            var _collapsedPaths  = {};     // path → true when collapsed
            var _currentMatchIdx = 0;
            var _searchDebounce  = null;

            // ── Lifecycle ─────────────────────────────────────────────────
            $ctrl.$onInit = function () {
                _parseJson();

                if ($ctrl.currentPath) {
                    $ctrl.selectedPath = $ctrl.currentPath;
                }

                _rebuildTree();

                if ($ctrl.currentPath) {
                    _validateAndPreview($ctrl.currentPath);
                }

                // Bridge for field selection clicks
                window.bizJsonSelectField = function (element) {
                    var path  = element.getAttribute('data-path');
                    var scope = angular.element(element).scope();
                    if (scope) {
                        scope.$apply(function () { scope.$ctrl.selectField(path); });
                    }
                };

                // Bridge for collapse toggle clicks
                window.bizJsonPathToggle = function (element) {
                    var path  = element.getAttribute('data-path');
                    var scope = angular.element(element).scope();
                    if (scope) {
                        scope.$apply(function () { scope.$ctrl._togglePath(path); });
                    }
                };
            };

            $ctrl.$onChanges = function (changes) {
                if (changes.jsonSample) {
                    _parseJson();
                    _collapsedPaths = {};
                    _rebuildTree();
                }
                if (changes.currentPath && !changes.currentPath.isFirstChange()) {
                    var val = changes.currentPath.currentValue;
                    $ctrl.selectedPath = val || null;
                    if (val) { _validateAndPreview(val); }
                    else     { $ctrl.pathPreview = null; }
                }
            };

            $ctrl.$onDestroy = function () {
                delete window.bizJsonSelectField;
                delete window.bizJsonPathToggle;
                if (_searchDebounce) { $timeout.cancel(_searchDebounce); }
            };

            // ── Field selection ───────────────────────────────────────────
            $ctrl.selectField = function (path) {
                $ctrl.selectedPath = path;
                _validateAndPreview(path);
                _updateSelectionClass(path);
            };

            $ctrl.clearSelection = function () {
                $ctrl.selectedPath = null;
                $ctrl.pathPreview  = null;
                _updateSelectionClass(null);
            };

            $ctrl.save = function () {
                if (!$ctrl.selectedPath) { return; }
                var valid = _validateAndPreview($ctrl.selectedPath);
                if (valid) { $ctrl.onSave({ path: $ctrl.selectedPath }); }
            };

            $ctrl.cancel = function () { $ctrl.onCancel(); };

            // ── Expand / Collapse ─────────────────────────────────────────
            $ctrl._togglePath = function (path) {
                _collapsedPaths[path] = !_collapsedPaths[path];
                _rebuildTree();
            };

            $ctrl.expandAll = function () {
                _collapsedPaths = {};
                _rebuildTree();
            };

            $ctrl.collapseAll = function () {
                _collectCollapsiblePaths(_parsedJson, '$');
                _rebuildTree();
            };

            function _collectCollapsiblePaths(node, path) {
                if (node === null || typeof node !== 'object') { return; }
                var isNonEmpty = Array.isArray(node)
                    ? node.length > 0
                    : Object.keys(node).length > 0;
                if (isNonEmpty) { _collapsedPaths[path] = true; }
                if (Array.isArray(node)) {
                    node.forEach(function (item, i) {
                        _collectCollapsiblePaths(item, path + '[' + i + ']');
                    });
                } else {
                    Object.keys(node).forEach(function (key) {
                        _collectCollapsiblePaths(node[key], path + '.' + key);
                    });
                }
            }

            // ── Search ────────────────────────────────────────────────────
            $ctrl.onSearch = function () {
                if (_searchDebounce) { $timeout.cancel(_searchDebounce); }
                _searchDebounce = $timeout(function () {
                    $ctrl.currentMatch = 1;
                    _rebuildTree();
                    if ($ctrl.matchCount > 0) { _scrollToMatch(0); }
                }, 180);
            };

            $ctrl.onSearchKeydown = function ($event) {
                if ($event.key === 'Enter')  { $event.preventDefault(); $ctrl.nextMatch(); }
                if ($event.key === 'Escape') { $ctrl.clearSearch(); }
            };

            $ctrl.clearSearch = function () {
                $ctrl.searchQuery  = '';
                $ctrl.matchCount   = 0;
                $ctrl.currentMatch = 0;
                _rebuildTree();
            };

            $ctrl.nextMatch = function () {
                if ($ctrl.matchCount === 0) { return; }
                $ctrl.currentMatch = ($ctrl.currentMatch >= $ctrl.matchCount) ? 1 : $ctrl.currentMatch + 1;
                _updateActiveMatch();
            };

            $ctrl.prevMatch = function () {
                if ($ctrl.matchCount === 0) { return; }
                $ctrl.currentMatch = ($ctrl.currentMatch <= 1) ? $ctrl.matchCount : $ctrl.currentMatch - 1;
                _updateActiveMatch();
            };

            // ── JSON parsing ──────────────────────────────────────────────
            function _parseJson() {
                var raw = $ctrl.jsonSample;
                try {
                    if (typeof raw === 'string') {
                        var parsed = JSON.parse(raw);
                        _parsedJson = (typeof parsed === 'string') ? JSON.parse(parsed) : parsed;
                    } else if (raw && typeof raw === 'object') {
                        _parsedJson = raw;
                    } else {
                        _parsedJson = {};
                    }
                } catch (e) {
                    _parsedJson = {};
                }
            }

            // ── Validation & preview ──────────────────────────────────────
            function _validateAndPreview(path) {
                if (!path) { $ctrl.pathPreview = null; return true; }
                if (typeof JSONPath === 'undefined') {
                    $ctrl.pathPreview = { valid: false, error: 'JSONPath library not loaded' };
                    return false;
                }
                try {
                    var query  = path.startsWith('$') ? path : '$.' + path;
                    var result = JSONPath.JSONPath({ path: query, json: _parsedJson, wrap: false });
                    $ctrl.pathPreview = { valid: true, value: result, type: typeof result, stringValue: JSON.stringify(result) };
                    return true;
                } catch (e) {
                    $ctrl.pathPreview = { valid: false, error: e.message || 'Invalid path' };
                    return false;
                }
            }

            // ── Tree rebuild ──────────────────────────────────────────────
            function _rebuildTree() {
                _currentMatchIdx = 0;
                var html         = _renderNode(_parsedJson, '$', 0);
                $ctrl.matchCount = _currentMatchIdx;

                if ($ctrl.currentMatch > $ctrl.matchCount) {
                    $ctrl.currentMatch = $ctrl.matchCount > 0 ? 1 : 0;
                }
                if ($ctrl.matchCount > 0 && $ctrl.currentMatch === 0) {
                    $ctrl.currentMatch = 1;
                }

                $ctrl.renderedTree = $sce.trustAsHtml(html);
            }

            // ── Rendering ─────────────────────────────────────────────────
            function _renderNode(node, path, level) {
                var indent = '  '.repeat(level);

                if (node === null)            { return indent + _selectableField(path, 'null', 'null'); }
                if (Array.isArray(node))      { return _renderArray(node,  path, level); }
                if (typeof node === 'object') { return _renderObject(node, path, level); }

                return indent + _selectableField(path, typeof node, _displayValue(node));
            }

            function _renderObject(obj, path, level) {
                var indent     = '  '.repeat(level);
                var nextIndent = '  '.repeat(level + 1);
                var keys       = Object.keys(obj);
                // During search: force-expand so matches inside collapsed nodes are visible
                var collapsed  = !!_collapsedPaths[path] && !$ctrl.searchQuery.trim();
                var safePath   = _escAttr(path);
                var html       = '';

                if (keys.length > 0) {
                    html += '<span class="bjps-toggle' + (collapsed ? ' collapsed' : '') + '" '
                         +  'data-path="' + safePath + '" '
                         +  'title="' + (collapsed ? 'Expand' : 'Collapse') + '" '
                         +  'onclick="bizJsonPathToggle(this)"></span>';
                } else {
                    html += '<span class="bjps-toggle-spacer"></span>';
                }

                html += '<span class="bjps-bracket">{</span>';

                if (collapsed) {
                    var kc = keys.length;
                    html += '<span class="bjps-hint"> … ' + kc + (kc === 1 ? ' key' : ' keys') + ' </span>';
                    html += '<span class="bjps-bracket">}</span>';
                    return indent + html;
                }

                if (keys.length === 0) {
                    html += '<span class="bjps-bracket">}</span>';
                    return indent + html;
                }

                html += '\n';
                keys.forEach(function (key, i) {
                    var value   = obj[key];
                    var newPath = path ? path + '.' + key : key;
                    html += nextIndent;
                    html += '<span class="bjps-key">"' + _highlight(key) + '"</span>: ';

                    if (value === null || typeof value !== 'object') {
                        html += _selectableField(newPath, typeof value, value === null ? 'null' : _displayValue(value));
                    } else {
                        html += '\n' + _renderNode(value, newPath, level + 1) + '\n' + nextIndent;
                    }

                    if (i < keys.length - 1) { html += '<span class="bjps-comma">,</span>'; }
                    html += '\n';
                });

                html += indent + '<span class="bjps-toggle-spacer"></span><span class="bjps-bracket">}</span>';
                return html;
            }

            function _renderArray(arr, path, level) {
                var indent     = '  '.repeat(level);
                var nextIndent = '  '.repeat(level + 1);
                var collapsed  = !!_collapsedPaths[path] && !$ctrl.searchQuery.trim();
                var safePath   = _escAttr(path);
                var html       = '';

                if (arr.length > 0) {
                    html += '<span class="bjps-toggle' + (collapsed ? ' collapsed' : '') + '" '
                         +  'data-path="' + safePath + '" '
                         +  'title="' + (collapsed ? 'Expand' : 'Collapse') + '" '
                         +  'onclick="bizJsonPathToggle(this)"></span>';
                } else {
                    html += '<span class="bjps-toggle-spacer"></span>';
                }

                html += '<span class="bjps-bracket">[</span>';

                if (collapsed) {
                    var ic = arr.length;
                    html += '<span class="bjps-hint"> … ' + ic + (ic === 1 ? ' item' : ' items') + ' </span>';
                    html += '<span class="bjps-bracket">]</span>';
                    return indent + html;
                }

                if (arr.length === 0) {
                    html += '<span class="bjps-bracket">]</span>';
                    return indent + html;
                }

                html += '\n';
                arr.forEach(function (item, i) {
                    var itemPath = path + '[' + i + ']';
                    html += nextIndent;
                    html += '<span class="bjps-array-index">[' + i + ']</span>: ';

                    if (item === null || typeof item !== 'object') {
                        html += _selectableField(itemPath, typeof item, item === null ? 'null' : _displayValue(item));
                    } else {
                        html += '\n' + _renderNode(item, itemPath, level + 1) + '\n' + nextIndent;
                    }

                    if (i < arr.length - 1) { html += '<span class="bjps-comma">,</span>'; }
                    html += '\n';
                });

                html += indent + '<span class="bjps-toggle-spacer"></span><span class="bjps-bracket">]</span>';
                return html;
            }

            function _selectableField(path, type, display) {
                var isSelected = (path === $ctrl.selectedPath);
                var classes    = 'bjps-field selectable' + (isSelected ? ' selected' : '');
                var safePath   = _escAttr(path);

                return '<span class="' + classes + '" '
                    + 'data-path="' + safePath + '" '
                    + 'onclick="bizJsonSelectField(this)">'
                    + '<span class="bjps-value ' + type + '">' + _highlight(display) + '</span>'
                    + '</span>';
            }

            function _displayValue(v) {
                if (typeof v === 'string') { return '"' + _esc(v) + '"'; }
                return String(v);
            }

            // ── Search highlight ──────────────────────────────────────────
            function _highlight(rawText) {
                var text = String(rawText);
                var q    = $ctrl.searchQuery ? $ctrl.searchQuery.trim() : '';

                if (!q) { return _esc(text); }

                var lower  = text.toLowerCase();
                var qLower = q.toLowerCase();
                var pos    = 0;
                var idx;
                var result = '';

                while ((idx = lower.indexOf(qLower, pos)) !== -1) {
                    result += _esc(text.slice(pos, idx));
                    var mIdx     = _currentMatchIdx;
                    var isActive = (mIdx === $ctrl.currentMatch - 1);
                    result += '<span class="bjps-match' + (isActive ? ' bjps-match-active' : '') + '" id="bjps-m-' + mIdx + '">';
                    result += _esc(text.slice(idx, idx + q.length));
                    result += '</span>';
                    _currentMatchIdx++;
                    pos = idx + q.length;
                }
                result += _esc(text.slice(pos));
                return result;
            }

            function _updateActiveMatch() {
                var all = document.querySelectorAll('.bjps-match');
                all.forEach(function (el, i) {
                    el.classList.toggle('bjps-match-active', i === $ctrl.currentMatch - 1);
                });
                _scrollToMatch($ctrl.currentMatch - 1);
            }

            function _scrollToMatch(index) {
                $timeout(function () {
                    var el = document.getElementById('bjps-m-' + index);
                    if (el) { el.scrollIntoView({ behavior: 'smooth', block: 'center' }); }
                }, 30);
            }

            // ── DOM helpers ───────────────────────────────────────────────
            function _updateSelectionClass(path) {
                $timeout(function () {
                    document.querySelectorAll('.bjps-field.selected').forEach(function (el) {
                        el.classList.remove('selected');
                    });
                    if (path) {
                        var el = document.querySelector('.bjps-field[data-path="' + _escAttr(path) + '"]');
                        if (el) { el.classList.add('selected'); }
                    }
                }, 30);
            }

            // ── Utilities ─────────────────────────────────────────────────
            function _esc(text) {
                return String(text).replace(/[&<>"']/g, function (ch) {
                    return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#039;' }[ch];
                });
            }

            function _escAttr(text) {
                return String(text).replace(/&/g, '&amp;').replace(/"/g, '&quot;');
            }

        }]
    });

}());